import { memo } from "react";
import Edit2LineIcon from "remixicon-react/Edit2LineIcon";
import { IconButton } from "$components/Buttons/IconButton";

export const ButtonEditInfoContainer = memo(function ButtonEditInfoContainer({
  onClick,
  disabled = false,
  className = "",
}: {
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}) {
  return (
    <IconButton
      icon={<Edit2LineIcon />}
      onClick={onClick}
      disabled={disabled}
      className={className}
    />
  );
});
